/*
 * @author Igor Serpak <robobee>
 */
angular.module('data.employee-invoice', []);
